import React from 'react';
import formatDropdownOptions from '../utils/formatDropdownOptions';
import fetchExpenseItems from './expenseItem/queries/fetchExpenseItems';
import getMasterExpenseData from './expenseItem/queries/getMasterDataExpense';
import getVendorList from './vendor/queries/getVendorList';
import { returnPolicies } from '../PermissionUtility/ProfilePolicies';

const withMasterData = (Component) => ({ ...props }) => {
  let categoryList = [];
  let accountCodeList = [];
  let isMasterLoading = false;
  let errorMaster = null;
  let isErrorMaster = false;
  const policies = returnPolicies();
  if (policies?.expensePolicies?.canAccess) {
    const {
      isLoading,
      error,
      data: masterData,
      isError
    } = getMasterExpenseData();

    isMasterLoading = isLoading;
    errorMaster = error;
    isErrorMaster = isError;

    categoryList = formatDropdownOptions(
      masterData?.data?.expenseCategory,
      'categoryName',
      'expenseCategoryID'
    );

    accountCodeList = formatDropdownOptions(
      masterData?.data?.accountCodeModel,
      'accountCode',
      'accountCodeID'
    );
  }
  const { data: vendorData } = getVendorList();
  const vendorDataList = formatDropdownOptions(vendorData?.data, 'vendorName', 'id');

  const {
    data: ExpenseItems } = fetchExpenseItems({ pageNumber: 1, rowsCount: 100000 });
  const expenseItemList = formatDropdownOptions(ExpenseItems?.data?.expenseItemModels, 'expenseLineItem', 'expenseLineItemID');

  return (
    <Component
      {...props}
      {...{
        expenseItemList,
        vendorDataList,
        isMasterLoading,
        errorMaster,
        isErrorMaster,
        categoryList,
        accountCodeList
      }}
    />

  );
};

export default withMasterData;
